import { Link } from 'react-router-dom';

import { WorkflowSubStepProps } from '../../config/workflow';

import './ConfirmationPage.css';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ConfirmationFormData {}

function ConfirmationPage(_props: WorkflowSubStepProps<ConfirmationFormData>) {
  const baseTestId = 'confirmation-page';

  return (
    <div
      aria-labelledby='confirmation-heading'
      className='confirmation-page'
      data-testid={baseTestId}
      role='main'>
      <div
        className='confirmation-page__content'
        data-testid={`${baseTestId}-content`}>
        <h1
          className='confirmation-page__heading'
          data-testid={`${baseTestId}-heading`}
          id='confirmation-heading'>
          What to expect next
        </h1>

        <p
          className='confirmation-page__body-text'
          data-testid={`${baseTestId}-body`}>
          Your application has been submitted and is now in review. You will receive updates as your application moves
          through each step in the process. You may see the status of your application and learn more about each step by
          going to the{' '}
          <Link
            className='ds-c-link'
            data-testid={`${baseTestId}-status-link`}
            to='/application/status'>
            Application Status
          </Link>{' '}
          page.
        </p>

        <div
          aria-labelledby='help-heading'
          className='confirmation-page__note-box'
          data-testid={`${baseTestId}-note`}
          role='complementary'>
          <h2
            className='confirmation-page__note-heading'
            data-testid={`${baseTestId}-note-heading`}
            id='help-heading'>
            Have Questions or Need Help?
          </h2>
          <p
            className='confirmation-page__note-text'
            data-testid={`${baseTestId}-note-text`}>
            If you have questions about your application or need assistance, contact your Contracting Officer
            Representative (COR).
          </p>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationPage;
